import {UserNotificationSubject} from "../../constant/user/UserNotificationSubject"
import {UserNotificationModificationVerboseDomain} from "../../domain/user/UserNotificationModificationVerboseDomain"
import {UserId} from "../../id/user/UserId"
import {UserNotificationId} from "../../id/user/UserNotificationId"
import {UserNotificationModificationId} from "../../id/user/UserNotificationModificationId"
import {UserNotificationValueObject} from "./UserNotificationValueObject"
import {UserValueObject} from "./UserValueObject"
import {VerboseValueObject} from "ts-protocol-extension"

/**
 * 사용자 알림 수정 이력 상세
 */
export class UserNotificationModificationVerboseValueObject implements VerboseValueObject, UserNotificationModificationVerboseDomain {
    /**
     * 기본키
     */
    id: UserNotificationModificationId
    /**
     * 수정자 ID
     */
    creatorId: UserId
    /**
     * 사용자 알림 ID
     */
    userNotificationId: UserNotificationId
    /**
     * 제목
     */
    title: string
    /**
     * 내용
     */
    body: string
    /**
     * 광고 주제
     */
    subject: UserNotificationSubject
    /**
     * 딥링크
     */
    deepLink?: string
    /**
     * 상태
     */
    statusFlags: number
    /**
     * 수정일
     */
    createdAt: Date
    /**
     * 수정자 ID
     */
    creator: UserValueObject
    /**
     * 사용자 알림 ID
     */
    userNotification: UserNotificationValueObject

    constructor(o: Record<keyof UserNotificationModificationVerboseDomain, any>) {
        this.id = BigInt(o.id)
        this.creatorId = BigInt(o.creatorId)
        this.userNotificationId = BigInt(o.userNotificationId)
        this.title = String(o.title)
        this.body = String(o.body)
        this.subject = o.subject as UserNotificationSubject
        if (o.deepLink !== undefined && o.deepLink !== null) {
            this.deepLink = String(o.deepLink)
        }
        this.statusFlags = Number(o.statusFlags)
        this.createdAt = new Date(o.createdAt)
        this.creator = new UserValueObject(o.creator)
        this.userNotification = new UserNotificationValueObject(o.userNotification)
    }
}
